'use strict';

var GridFetchHostShareButtonDirective = function GridFetchHostShareButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-fetch-host-share-button.html'),
    controller: 'GridFetchHostShareButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridFetchHostShareButtonDirective.$inject = [];
module.exports = GridFetchHostShareButtonDirective;